import { Text, Spacer } from "@hackthenorth/north";
import React from "react";
import styled from "styled-components";

import { OptionConfig } from "./constants";
import OptionCard from "./OptionCard";

interface OptionGroupProps {
  label: string;
  options: OptionConfig[];
  selected: string;
  onSelect: (value: string) => void;
}

const OptionGroup: React.FC<OptionGroupProps> = ({
  label,
  options,
  selected,
  onSelect,
}) => (
  <div role="group" aria-label={label}>
    <Text mods="bold">{label}</Text>
    <Spacer height={8} />
    <Row>
      {options.map((option) => (
        <OptionCard
          key={option.value}
          label={option.label}
          icon={option.icon}
          selected={selected === option.value}
          disabled={option.disabled}
          onClick={() => onSelect(option.value)}
        />
      ))}
    </Row>
  </div>
);

const Row = styled.div`
  display: flex;
  gap: 12px;
`;

export default OptionGroup;
